/** @license ISC License (c) copyright 2016 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var curry = require('../core/curry')

// Constant (Kestrel)
// constant : a -> b -> a
var constant =
  function (x) { return function () { return x; }; }

module.exports = curry(constant)
